import React from 'react'
import { mappingType, selectedMappingId } from 'Pages/User/CustomMapping/@signals'
import { MAPPING_TYPE } from 'Pages/User/CustomMapping/@constants'
import { AppFormDrawer } from '@components'
import MappingDrawerFooter from 'Pages/User/CustomMapping/EditDrawer/Footer'
import MappingDrawerContent from 'Pages/User/CustomMapping/EditDrawer/Content'
import { isEmpty } from '@ui-seeker/utils'
import { batch, useComputed } from '@preact/signals-react'
import { formData } from '@signals'

export default function EditMappingDrawer() {

	const isDataEmpty = useComputed(() => isEmpty(formData.value))

	if (isDataEmpty.value) return null

	return <AppFormDrawer
		icon="diagram-project"
		title={mappingType.value === MAPPING_TYPE.ACRISS ? 'Custom Acriss Mapping' : 'Custom Categories Mapping'}
		subtitle="Where it applies and the vehicle it maps"
		width={640}
		isOpen={!isDataEmpty.value}
		controller={() => batch(() => {
			formData.value = {}
			selectedMappingId.value = null
		})}
		footer={<MappingDrawerFooter/>}
	>
		<MappingDrawerContent/>
	</AppFormDrawer>

}